module.exports = __webpack_public_path__ + "img/55exp.a3466918.jpg";